import React from "react";
import { Forma } from "./_Forma";
import { Listado } from "./_Listado";
import { Divider } from "antd";
import { FormaPropuestoGnp } from "./_FormaPropuestoGnp";

export const DetalleCostos = () => {
  return (
    <>
      <FormaPropuestoGnp />
      <Divider />
      <Forma />
      <Divider />
      <Listado />
    </>
  );
};
